'use client';

import { Box, Button, Typography, Stack } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
    const { themeStyle } = useThemeContext();
    const textColor = theme[themeStyle].tag_white;
    const borderColor = textColor;
    const hoverBg = themeStyle === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" sx={{ color: textColor }}>
                Page {currentPage} of {totalPages}
            </Typography>

            <Stack direction="row" spacing={1}>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<ChevronLeft size={16} />}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                    sx={{
                        color: textColor,
                        borderColor,
                        '&:hover': {
                            backgroundColor: hoverBg,
                        },
                        '&.Mui-disabled': {
                            color: 'rgba(255, 255, 255, 0.3)',
                            borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                    }}>
                    Previous
                </Button>

                <Button
                    variant="outlined"
                    size="small"
                    endIcon={<ChevronRight size={16} />}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                    sx={{
                        color: textColor,
                        borderColor,
                        '&:hover': {
                            backgroundColor: hoverBg,
                        },
                        '&.Mui-disabled': {
                            color: 'rgba(255, 255, 255, 0.3)',
                            borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                    }}>
                    Next
                </Button>
            </Stack>
        </Box>
    );
}
